/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { Coordinate } from './Coordinate';

export type MultiLineString = {
    type: MultiLineString.type;
    coordinates: Array<Array<Coordinate>>;
    bbox?: Array<number>;
};

export namespace MultiLineString {

    export enum type {
        MULTI_LINE_STRING = 'MultiLineString',
    }


}

